<template>
    <div class="form-component">
        <v-form ref="form" v-model="valid">
            <h3 class="form-title">
                <v-btn fab color="primary" @click="goTo('/userlist')">
                    <v-icon large>arrow_left</v-icon>
                </v-btn>
                {{ title }} Usuario
            </h3>
            
            <v-container fluid class="pa-0">
                <v-layout row wrap>
                    <!-- ROW ONE -->
                    <v-flex xs12 md4>
                        <v-text-field class="lance"
                            label="Nombre(s)"
                            v-model="form.firstName"
                            :rules="[v => !!v || 'Campo requerido']"
                            :disabled="view">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12 md4>
                        <v-text-field class="lance"
                            label="Apellidos"
                            v-model="form.lastName"
                            :disabled="view">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12 md4>
                        <v-text-field class="lance"
                            label="Correo Electrónico"
                            v-model="form.email"
                            :disabled="view"
                            :rules="[
                                v => !!v || 'Campo requerido',
                                v => /.+@.+/.test(v) || 'Campo no válido',
                                v => /.+@(?:whirlpool\.com|ltmexico\.net|bluepeople\.com|moviro\.mx)/.test(v) || 'Dominio no válido'
                            ]">
                        </v-text-field>
                    </v-flex>

                    <!-- ROW TWO -->
                    <v-flex xs12 md4>
                        <v-autocomplete class="lance"
                            v-model="form.countryId"
                            :items="countries"
                            item-text="name"
                            item-value="id"
                            label="País"
                            :filter="customFilter"
                            :disabled="view"
                            @input="updateStates()">
                                <template slot="item" slot-scope="props"><span v-html="props.item.name"></span></template>
                        </v-autocomplete>
                    </v-flex>
                    <v-flex xs12 md4>
                        <v-autocomplete class="lance"
                            v-model="form.stateId"
                            :items="states"
                            item-text="name"
                            item-value="id"
                            label="Estado"
                            :filter="customFilter"
                            :disabled="!form.countryId || view"
                            @input="updateCities()">
                                <template slot="item" slot-scope="props"><span v-html="props.item.name"></span></template>
                        </v-autocomplete>
                    </v-flex>
                    <v-flex xs12 md4>
                        <v-autocomplete class="lance"
                            v-if="form.countryId == 42"
                            v-model="form.cityId"
                            :items="cities"
                            item-text="name"
                            item-value="id"
                            label="Ciudad"
                            :disabled="!form.countryId || !form.stateId || view">
                                <template slot="item" slot-scope="props"><span v-html="props.item.name"></span></template>
                        </v-autocomplete>

                        <v-text-field class="lance"
                            v-if="form.countryId != 42"
                            v-model="form.cityName"
                            label="Ciudad"
                            :disabled="!form.countryId || !form.stateId || view"></v-text-field>
                    </v-flex>
                    
                    <v-flex xs12 md4>
                        <v-text-field class="lance"
                            label="Teléfono"
                            prefix="+"
                            v-model="form.phone"
                            :disabled="view"
                            :rules="[
                                v => (v === undefined || v===null || /(^$)|(^[0-9]{1,3}( )*([0-9]){0,1}( )*[0-9]{3}( )*[0-9]{3}( )*[0-9]{4}$)/.test(v)) || 'Formato inválido'
                            ]"
                            @input="filterPhone">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12 md4 class="blocked-switch" v-if="form.blocked">
                        <span class="mr-4">Bloqueado</span>
                        <v-switch
                            v-model="blocked"
                            style="display: inline-block;"
                            color="primary"
                            :disabled="view">
                        >
                        </v-switch>
                    </v-flex>

                    <v-flex xs12 class="divider"></v-flex>

                    <v-flex xs12 md4>
                        <v-text-field class="lance"
                            label="Usuario"
                            v-model="form.username"
                            :rules="[v => !!v || 'Campo requerido']"
                            :disabled="view">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12 md4>
                        <v-text-field class="lance"
                            v-if="!view && !add"
                            label="Contraseña"
                            v-model="form.password"
                            type="password"
                            :rules="[
                                v => (!form.blocked || blocked && form.blocked || !blocked && form.blocked && !!v) || 'Ingresa nueva contraseña'
                            ]"
                            :disabled="view">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12 md4>
                        <v-text-field class="lance"
                            v-if="!view && !add"
                            label="Confirmar Contraseña"
                            v-model="form.confirmPassword"
                            type="password"
                            :rules="[ v => v === form.password || 'Contraseña no coincide' ]"
                            :disabled="view">
                        </v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12>
                        <div class="table-catalog table-catalog-border-first elevation-5">
                            <table class="v-datatable v-table theme--light">
                                <thead>
                                    <tr>
                                        <th class="text-xs-left" width="300px">Roles</th>
                                        <th class="text-xs-left">Alta</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="role in roles" :key="role.id">
                                        <td class="py-2" style="font-family: 'Montserrat', sans-serif;" v-text="role.name"></td>
                                        <td>
                                            <v-switch v-model="role.selected" @change="selectRole(role)" 
                                                :disabled="view" color="primary" hide-details></v-switch>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12 md4>
                        <v-btn v-if="!view" solo color="submitBtn" @click="save()" :disabled="!valid || sending">Guardar</v-btn>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-form>
    </div>
</template>

<style scoped>
.image-input {
    margin: 20px 125px;
}

.blocked-switch {
    font-size: 16px;
    margin-left: 50px;
}
</style>

<script>
    import { events } from '../main';
    import { _ } from 'underscore';
    import moment from 'moment-timezone';
    import Swatches from 'vue-swatches';
    import IconPicker from './modals/icon-picker';
    import ImagePicker from './imagePicker';
    import ImageCroppaPicker from './imageCroppaPicker';
    import ColorPicker from './colorPicker';
    import { removeDiacritics } from "@/utils/string";

    export default {
        name: 'userform',
        components: {
            Swatches,
            IconPicker,
            ImagePicker,
            ColorPicker,
            ImageCroppaPicker,
        },
        data() {
            return {
                add: false,
                title: 'Nuevo',
                valid: true,
                sending: false,
                view: false,
                blocked: false,
                id: '',
                form: {
                },
                roles: [],
                countries: [],
                states: [],
                cities: [],
                credentials: JSON.parse(localStorage.getItem('userCredentials')),
            }
        },
        methods: {
            filterPhone() {
                this.$nextTick(() => {
                  this.form.phone = this.form.phone.replace(/[^0-9 \,]/, '');
                });
            },
            customFilter(item, queryText, itemText) {
                return removeDiacritics(itemText).indexOf(removeDiacritics(queryText)) > -1;
            },
            snackbar(message, options=null) {
                events.$emit('snackbar', message, options);            
            },
            goTo(url) {
                this.$router.push(url);
            },
            dataInit() {
                var self = this;
                if (this.id) {
                    this.getRegistry(this.id);
                } else {
                    this.$http.get('user/form')
                    .then(response => {
                        var newform = response.body.user;
                        this.form = newform;
                        this.countries = response.body.countries;

                        this.roles = response.body.roles;
                        _.each(this.roles, (role) => {
                            var userrole = _.find(this.form.roles, (userrole) => {
                                return role.id === userrole.id
                            });
                            if(userrole) {
                                role.selected = true;
                            }
                        });

                    });
                }
            },
            selectRole(role) {
                if(!role.selected) {
                    this.form.roles = _.filter(this.form.roles, (userrole) => {
                        return userrole.id !== role.id;
                    });
                } else {
                    if (!this.form.roles) {
                        this.form.roles = [];
                    }
                    this.form.roles.push(role);
                }
            },
            getRegistry(id) {
                this.$http.get('user/form/' + id)
                    .then(response => {
                        this.form = response.body.user;
                        if (this.form.countryId)
                            this.updateStates();
                        if (this.form.stateId)
                            this.updateCities();

                        this.roles = response.body.roles;
                        this.countries = response.body.countries;
                        this.blocked = this.form.blocked;
                        _.each(this.roles, role => {
                            var userrole = _.find(this.form.roles, (userrole) => {
                                return role.id === userrole.id
                            });
                            if(userrole) {
                                role.selected = true;
                            }
                        });
                        /*if (response.body.user.blocked)
                            this.snackbar('Este usuario se encuentra bloqueado', { timeout: 0 });*/

                        
                    }, error => {
                        this.snackbar('Error al obtener registro');
                        this.$router.push('/userlist');
                    });
            },
            save() {
                if (this.$refs.form.validate()) {
                    this.sending = true;                    
                    if (this.id) {
                        this.form.updatedById = localStorage.getItem('userId');
                        this.$http.put('user/' + this.id, this.form)
                            .then(response => {
                                this.snackbar('Registro actualizado con éxito');
                                this.$router.push('/userlist');                                
                            }, error => {
                                this.sending = false;                                
                                var message = error.body.msg || 'Error al actualizar registro';
                                this.snackbar(message);
                                console.error(error);
                        });
                    } else {
                        this.form.createdById = localStorage.getItem('userId');
                        this.form.updatedById = localStorage.getItem('userId');
                        this.$http.post('user/', this.form)
                            .then(response => {
                                this.snackbar('Registro creado con éxito');
                                this.$router.push('/userlist');   
                            }, error => {
                                this.sending = false;                                
                                var message = error.body.msg || 'Error al crear registro';
                                this.snackbar(message);
                                console.error(error);
                            });
                    }
                }
            },
            updateStates() {
                this.states = this.cities = [];
                this.$http.get(`locations/getstates/${this.form.countryId}`).then(
                    result => {
                        this.states = result.body;
                    },
                    error => {
                        this.snackbar(error.body.msg || "No se pudo obtener los estados del pais");
                    }
                )
            },
            updateCities() {
                this.cities = [];
                this.$http.get(`locations/getcities/${this.form.stateId}`).then(
                    result => {
                        this.cities = result.body;
                    },
                    error => {
                        this.snackbar(error.body.msg || "No se pudo obtener las ciudades del estado");
                    }
                )
            }
        },
        mounted() {
            this.id = this.$route.params.id;
            if (this.$route.name.includes('detail') ) {
                this.view = true;
                this.title = "Detalle de";
            } else if (this.$route.name.includes('edit')) {
                this.view = false;
                this.title = "Editar";
            } else {
                this.add = true;
            }
            this.dataInit();
        }
    }
</script>